import type { OpportunitySource } from "./db-types";

/** Hvem sin pipe som vises: mine, alle, eller en bestemt rådgiver (bruker-id). */
export type PipePerson = "mine" | "all" | (string & {});
export type PipeSourceFilter = "all" | OpportunitySource;

export interface PipeFilter {
  person: PipePerson;
  source: PipeSourceFilter;
}

export const PIPE_FILTER_STORAGE_KEY = "crm_pipe_filter";

const SOURCES: readonly PipeSourceFilter[] = ["all", "signal", "lead", "manual"];

/** DL og admin ser alle som standard, andre ser sine egne. */
export function defaultPipeFilter(isAdmin: boolean): PipeFilter {
  return { person: isAdmin ? "all" : "mine", source: "all" };
}

/** Leser lagret filter; ugyldig eller manglende innhold gir standard. */
export function parsePipeFilter(raw: string | null, isAdmin: boolean): PipeFilter {
  const fallback = defaultPipeFilter(isAdmin);
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw) as Partial<PipeFilter> | null;
    const person = typeof parsed?.person === "string" && parsed.person.length > 0 ? parsed.person : fallback.person;
    const source = SOURCES.includes(parsed?.source as PipeSourceFilter) ? (parsed!.source as PipeSourceFilter) : "all";
    return { person, source };
  } catch {
    return fallback;
  }
}

/** Bruker-id som filtrerer spørringen, eller undefined for alle. */
export function pipeOwnerId(filter: PipeFilter, myUserId: string | undefined): string | undefined {
  if (filter.person === "all") return undefined;
  if (filter.person === "mine") return myUserId;
  return filter.person;
}
